import {DndContext} from "@dnd-kit/core"
import React from "react"
import {getMerkmal} from "../../misc/widget-functions"
import Content from "../../components/Content"

const ContainerDragAndDrop = ({
    container,
    disabled,
    getDataFromPointer,
    updateData,
}) => {
    const merkmal = getMerkmal(container)
    const savePointer = merkmal?.pointer
    const dropareaContent = getDataFromPointer(savePointer)

    const setDropareaContent = (newValue) => {
        updateData(newValue, savePointer)
    }

    const handleDragEnd = (event) => {
        const {active, over} = event

        if (over) {
            const sourceContainerId = Object.keys(dropareaContent).find((key) =>
                dropareaContent[key].find((obj) => obj.id === active.id),
            )
            const newDropareaContent = {...dropareaContent}

            if (sourceContainerId) {
                newDropareaContent[sourceContainerId] = newDropareaContent[
                    sourceContainerId
                ].filter((object) => object.id !== active.id)
            }

            if (
                !newDropareaContent[over.id].some((obj) => obj.id === active.id)
            ) {
                newDropareaContent[over.id] = [
                    ...newDropareaContent[over.id],
                    dropareaContent[sourceContainerId].find(
                        (obj) => obj.id === active.id,
                    ),
                ]
            }
            updateData(newDropareaContent, savePointer)
            setDropareaContent(newDropareaContent)
        }
    }

    return (
        <DndContext onDragEnd={handleDragEnd}>
            {container.children.map((container) => (
                <Content
                    key={container.id}
                    child={container}
                    disabled={disabled}
                />
            ))}
        </DndContext>
    )
}

export default ContainerDragAndDrop
